import { render, staticRenderFns } from "./plantao.vue?vue&type=template&id=2b755f4a"
import script from "./plantao.vue?vue&type=script&lang=js"
export * from "./plantao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports